import { motion } from "framer-motion";
import { ChapterLabel } from "@/components/Expertise";
import { useLanguage } from "@/i18n/LanguageContext";

const LANGS = [
  { code: "fr", name: "Français" },
  { code: "en", name: "English" },
  { code: "ru", name: "Русский" },
  { code: "ua", name: "Українська" },
];

export default function Languages() {
  const { t } = useLanguage();

  return (
    <section id="langues" data-testid="languages-section" className="bg-midnight py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <ChapterLabel num="03" title={t("languages.label")} dark />
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="font-serif font-light text-4xl sm:text-5xl tracking-tight text-paper max-w-3xl mb-16"
        >
          {t("languages.title")}
        </motion.h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-paper/10 border border-paper/10">
          {LANGS.map((l, i) => (
            <motion.div
              key={l.code}
              data-testid={`language-card-${l.code}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="bg-midnight p-10 hover:bg-[#101828] transition-colors duration-500"
            >
              <p className="text-[11px] uppercase tracking-[0.3em] text-brasslight mb-6">{l.code.toUpperCase()}</p>
              <p className="font-serif font-light text-3xl lg:text-4xl text-paper mb-3">{l.name}</p>
              <p className="text-sm text-paper/50">{t(`languages.notes.${l.code}`)}</p>
            </motion.div>
          ))}
        </div>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-12 text-sm text-paper/50 max-w-2xl leading-relaxed"
        >
          {t("languages.p")}
        </motion.p>
      </div>
    </section>
  );
}
